import { Command } from "./Command";
import _ from "lodash";
import {ConvrrtFirebase} from "../convrrt-firebase";
import * as actions from "../store/modules/actions";


export class PopupPropertyChangeCommand extends Command {
    constructor(DbPath, fbNode, dispatch, key, newValue) {
        super();
        this._fbNode = fbNode
        this._firebaseKey = key
        this._firebaseRef = new ConvrrtFirebase(DbPath)
        this._newValue =  newValue
        this._lodashKey = key.split("/").join(".")
        this._oldValue = _.clone(_.get(this.fbNode, this._lodashKey, ""))
        this._dispatch = dispatch
    }

    get hasChanges () {
        return _.isEqual(this._newValue, this._oldValue) === false;
    }

    get fbNode() {
        return this._fbNode
    }

    get firebaseRef() {
        return this._firebaseRef
    }

    async execute() {
        this.firebaseRef.setChild(this._firebaseKey, this._newValue).then(()=> {
            _.set(this.fbNode, this._lodashKey, this._newValue)
        })
    }

    async unExecute() {
        this.firebaseRef.setChild(this._firebaseKey, this._oldValue).then(()=> {
            _.set(this.fbNode, this._lodashKey, this._oldValue)
            this._dispatch(actions.SELECTOR_DESELECT)
        })
    }
}
